export default __webpack_public_path__ + "static/media/base.6c5c13c1.svg";